import axios from 'axios';
import dayjs from 'dayjs';
import {get} from 'lodash';

const axiosInstance = axios.create();
const clientSide = (typeof window === 'object');
const isJsonString = function (str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

axiosInstance.interceptors.request.use((config) => {
    if (clientSide && window.localStorage.getItem('accessToken')) {
        axiosInstance.defaults.headers.common.Authorization = "Bearer " + window.localStorage.getItem('accessToken');
        config.headers.Authorization = "Bearer " + window.localStorage.getItem('accessToken');
    }
    if (clientSide && window.localStorage.getItem('selectedCompany')) {
        let selectedCompany = isJsonString(window.localStorage.getItem('selectedCompany')) ? JSON.parse(window.localStorage.getItem('selectedCompany')) : {};
        axiosInstance.defaults.headers.common['Company-ID'] = get(selectedCompany,'hs.company.id');
        config.headers['Company-ID'] = get(selectedCompany,'hs.company.id');
    }
    let jurisdiction = (clientSide && window.localStorage.getItem('jurisdiction') && isJsonString(window.localStorage.getItem('jurisdiction')))
        ? JSON.parse(window.localStorage.getItem('jurisdiction'))
        : { i18n: "en-US" };
    axiosInstance.defaults.headers.common['Language-Tag'] = jurisdiction.i18n;
    config.headers['Language-Tag'] = jurisdiction.i18n;
    let utcOffset = dayjs().format("Z")
    axiosInstance.defaults.headers.common['Timezone-Offset'] = utcOffset;
    config.headers['Timezone-Offset'] = utcOffset;

    return config;
}, (error) => {
    return Promise.reject(error);
})

axiosInstance.interceptors.response.use((response) => {
        return response
    },
    function (error) {
        const originalRequest = error.config;
        if (error.response.status === 401 &&
            originalRequest.url === `${ process.env.VUE_APP_API_DUTYPAY }/api/v0/refresh`) {
            window.location.href = process.env.VUE_APP_HOST_SSO + '/login?redirect=' + encodeURIComponent(process.env.VUE_APP_BASE_URL);
            return Promise.reject(error);
        }
        if (clientSide && error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            let refreshToken = window.localStorage.getItem('refreshToken')
            return axiosInstance({
                url: `${ process.env.VUE_APP_API_DUTYPAY }/api/v0/refresh`,
                data: { refreshToken },
                method: 'POST'
            })
                .then(res => {
                    // 1) put token to LocalStorage
                    window.localStorage.setItem('accessToken', res.data.accessToken)
                    window.localStorage.setItem('refreshToken', res.data.refreshToken)

                    // 2) Change Authorization header
                    axiosInstance.defaults.headers.common.Authorization = "Bearer " + window.localStorage.getItem('accessToken');
                    originalRequest.headers.Authorization = "Bearer " + window.localStorage.getItem('accessToken');
                    // 3) return originalRequest object with Axios.
                    return axiosInstance(originalRequest);
                })
        }
        // return Error object with Promise
        return Promise.reject(error);
    })

export { axiosInstance as interceptor }